export const IGNORE_INPUT_CHANGE_EVENTS = <const>['blur', 'click', 'keydown'];
